// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"28":"4dfa2e3f2030ae9f","210":"f78ecbd32e0465b7"}[chunkId] + ".css";
};